// extracted by mini-css-extract-plugin
module.exports = {"links":"Links__links___2v9z0"};